import { jsx as _jsx } from "react/jsx-runtime";
const MissionTableFilters = ({ filters, onFilterChange }) => {
    return (_jsx("div", { className: "flex flex-wrap gap-4 mb-4 items-center", children: _jsx("input", { type: "text", value: filters?.label, onChange: (e) => onFilterChange("label", e.target.value), placeholder: "Rechercher...", className: "border p-2 rounded w-full sm:w-auto" }) }));
};
export default MissionTableFilters;
